// Enum values double as the lowercase URL token (e.g. /acme/operator/procure).
export enum PersonaMode {
  Analyst = 'analyst',
  Operator = 'operator',
  Supplier = 'supplier',
  Finance = 'finance',
}

export const PERSONA_MODE_ORDER: PersonaMode[] = [
  PersonaMode.Analyst,
  PersonaMode.Operator,
  PersonaMode.Supplier,
  PersonaMode.Finance,
];

export const DEFAULT_PERSONA_MODE = PersonaMode.Analyst;

export type PersonaModeMeta = {
  label: string;
  description: string;
};

export const PERSONA_MODE_META: Record<PersonaMode, PersonaModeMeta> = {
  [PersonaMode.Analyst]: {
    label: 'Analyst',
    description: 'Predict prices and hedge price exposure',
  },
  [PersonaMode.Operator]: {
    label: 'Business operator',
    description: 'Publish needs, procure, and run workflows',
  },
  [PersonaMode.Supplier]: {
    label: 'Supplier',
    description: 'Commit supply against demand signals',
  },
  [PersonaMode.Finance]: {
    label: 'Finance',
    description: 'Collect payments, pay global suppliers and more',
  },
};

export const PERSONA_MODE_COOKIE = 'nullifyrisk_persona_mode';

export const isPersonaMode = (value: unknown): value is PersonaMode => {
  return typeof value === 'string' && PERSONA_MODE_ORDER.includes(value as PersonaMode);
};
